// extracted by mini-css-extract-plugin
module.exports = {"root":"DeviceContainerDashboardLogs_root__3Lu5s","logHeader":"DeviceContainerDashboardLogs_logHeader__1aBUT","logDate":"DeviceContainerDashboardLogs_logDate__1W7OK"};